import { takeEvery, put } from 'redux-saga/effects'

import { modal } from 'store/entities/modal/actions'
import { saveOrgValue } from '../actions'

export default function* saveOrgValueSuccessEach() {
  yield takeEvery(saveOrgValue.success, saveOrgValueSuccessHandler)
}

export function* saveOrgValueSuccessHandler() {
  yield put(modal.hide())
}
